export const refreshOnlyTheMatchOnScreen = <T extends { id: string }>(
  matchOnScreen: T | null,
  refreshedMatch: T
) => (matchOnScreen?.id === refreshedMatch.id ? refreshedMatch : matchOnScreen);
